import { Check } from "lucide-react";

const journeySteps = [
  "Idea", "Review", "CAD", "Quote", "Payment", "Scheduled",
  "Manufacturing", "QC", "Dispatch", "Delivered",
];

export default function PrototypeJourney({ projectId = "APIC-2411-0142", currentIndex = 6 }) {
  return (
    <div style={{ scrollbarWidth:"thin"}} className="bg-white border border-gray-100 rounded-2xl p-6 overflow-x-auto">
      <h2 className="font-bold text-gray-900 mb-6">
        Prototype Journey · {projectId}
      </h2>

      <div className="flex items-center min-w-max">
        {journeySteps.map((step, i) => {
          const isDone = i < currentIndex;
          const isCurrent = i === currentIndex;
          return (
            <div key={step} className="flex items-center">
              <div className="flex flex-col items-center gap-2 w-24">
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold ${
                    isDone
                      ? "bg-green-500 text-white"
                      : isCurrent
                      ? "bg-indigo-600 text-white"
                      : "bg-gray-100 text-gray-400"
                  }`}
                >
                  {isDone ? <Check className="w-4 h-4" /> : i + 1}
                </div>
                <span
                  className={`text-xs text-center ${
                    isCurrent ? "font-bold text-gray-900" : "text-gray-500"
                  }`}
                >
                  {step}
                </span>
              </div>
              {i < journeySteps.length - 1 && (
                <div
                  className={`h-0.5 w-10 ${
                    i < currentIndex ? "bg-green-500" : "bg-gray-200"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}